import {
    Directive,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    Renderer2,
    EventEmitter,
    Output,
} from '@angular/core';

@Directive({
    selector: 'input,textarea[dbsInputMaxLengthByte]',
})
export class InputMaxLengthByteDirective implements OnInit {
    @Input() dbsInputMaxLengthByte: number;
    @Output() ngModelChange: EventEmitter<any> = new EventEmitter(false);
    maxLength = 0;
    max = 0;
    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('input') onInputChange() {
        this.maxLength = this.byteLength(this.el.nativeElement.value, this.dbsInputMaxLengthByte);
        if (this.maxLength) {
            if (this.maxLength !== this.dbsInputMaxLengthByte) {
                const maxValue = this.max ? this.max + 1 : 0;
                const value = this.el.nativeElement.value.length - maxValue;
                this.el.nativeElement.value = this.el.nativeElement.value.substr(
                    0, this.el.nativeElement.value.length - value,
                );
            }
            this.ngModelChange.emit(this.el.nativeElement.value);
        }
    }

    ngOnInit() {
        this.maxLength = this.byteLength(this.el.nativeElement.value, this.dbsInputMaxLengthByte);
        if (this.maxLength) {
            this.renderer.setAttribute(this.el.nativeElement, 'maxLength', this.maxLength.toString());
        }
    }

    byteLength(str, maxLength: number): number {
        // returns the byte length of an utf8 string
        if (str) {
            let s = 0;
            for (let i = 0; i <= str.length - 1; i++) {
                const code = str.charCodeAt(i);
                if (code > 0x7f && code <= 0x7ff) {
                    s++;
                    if (s === maxLength) {
                        this.max = i;
                    }
                } else if (code > 0x7ff && code <= 0xff70) {
                    s += 2;
                    if (s === maxLength) {
                        this.max = i;
                    }
                } else {
                    s += 1;
                    if (s === maxLength) {
                        this.max = i;
                    }
                }
            }
            if (Number(s) > maxLength) {
                return str.length - 1;
            } else if (Number(s) === maxLength) {
                return str.length;
            } else {
                return maxLength;
            }
        } else {
            return maxLength;
        }
    }
}
